// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  box-sizing: border-box;
  position: relative;
  /* max-width: 1400px;
  margin: auto; */
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

figure {
  margin: 0;
}

img {
  width: 100%;
  height: 100%;
}

p,
h1 {
  margin-block: 5px;
}

a {
  text-decoration: none;
}

ul {
  list-style: none;
  padding-left: 0;
}

.errorMessage {
  color: #ff2e2e;
  font-size: 12px;
  font-weight: 400;
  margin: 5px 0 0 5px;
}

svg {
  cursor: pointer;
}

.container {
  background: white;
  padding: 20px;
  border-radius: 6px;
}

input[type="date"] {
  appearance: none;
  &::-webkit-calendar-picker-indicator {
    cursor: pointer;
  }
  &::-moz-appearance-calendar-picker-indicator {
    cursor: pointer;
  }
}

.hyperLink {
  color: #1d53b5;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.inputIconContainer {
  position: absolute;
  top: 50%;
  right: 3%;
  transform: translate(-50%, -50%);
  background: white;
}

.tableContainer {
  overflow: auto;
  border-radius: 6px;
}

.tableContainer::-webkit-scrollbar {
  height: 0.375rem;
  width: 0.375rem;
  border-radius: 3.125rem;
}

.tableContainer::-webkit-scrollbar-thumb {
  border-radius: 3.125rem;
  -webkit-box-shadow: inset 0 0 100px var(--primary-themeColor);
}

.link {
  color: #181c5c;
  cursor: pointer;
  font-weight: 500;
}

/* .rbc-event {
  left: 0% !important;
  width: 100% !important;
} */

/*
 This is causing inconsitency of data in month view calendar
.rbc-event-content {
  font-size: 12px !important;
} */

/* Class to remove spacing from slots in day and week view */
.rbc-day-slot .rbc-events-container {
  margin-right: 0 !important;
}

/* Hide the current time indicator green line */
/* .rbc-current-time-indicator {
  display: none;
} */

/*
 To add the scrolling in month view if slots are multiple
.rbc-row-content-scroll-container {
  height: 100%;
  overflow-y: auto !important;

  &::-webkit-scrollbar {
    width: 10px !important;
  }
  scrollbar-width: thin !important;
  -ms-overflow-style: scrollbar !important;
} */

.rbc-overlay {
  max-height: 150px !important;
  overflow: auto;
  max-width: 400px !important;
}

.maxwidth {
  width: max-content;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB;iBACe;AACjB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EAGE,gBAAgB;EAChB;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;;;;GAIG;;AAEH,4DAA4D;AAC5D;EACE,0BAA0B;AAC5B;;AAEA,+CAA+C;AAC/C;;GAEG;;AAEH;;;;;;;;;;;GAWG;;AAEH;EACE,4BAA4B;EAC5B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  position: relative;\n  /* max-width: 1400px;\n  margin: auto; */\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\nfigure {\n  margin: 0;\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n}\n\np,\nh1 {\n  margin-block: 5px;\n}\n\na {\n  text-decoration: none;\n}\n\nul {\n  list-style: none;\n  padding-left: 0;\n}\n\n.errorMessage {\n  color: #ff2e2e;\n  font-size: 12px;\n  font-weight: 400;\n  margin: 5px 0 0 5px;\n}\n\nsvg {\n  cursor: pointer;\n}\n\n.container {\n  background: white;\n  padding: 20px;\n  border-radius: 6px;\n}\n\ninput[type=\"date\"] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  &::-webkit-calendar-picker-indicator {\n    cursor: pointer;\n  }\n  &::-moz-appearance-calendar-picker-indicator {\n    cursor: pointer;\n  }\n}\n\n.hyperLink {\n  color: #1d53b5;\n  font-size: 14px;\n  font-weight: 400;\n  cursor: pointer;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.inputIconContainer {\n  position: absolute;\n  top: 50%;\n  right: 3%;\n  transform: translate(-50%, -50%);\n  background: white;\n}\n\n.tableContainer {\n  overflow: auto;\n  border-radius: 6px;\n}\n\n.tableContainer::-webkit-scrollbar {\n  height: 0.375rem;\n  width: 0.375rem;\n  border-radius: 3.125rem;\n}\n\n.tableContainer::-webkit-scrollbar-thumb {\n  border-radius: 3.125rem;\n  -webkit-box-shadow: inset 0 0 100px var(--primary-themeColor);\n}\n\n.link {\n  color: #181c5c;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n/* .rbc-event {\n  left: 0% !important;\n  width: 100% !important;\n} */\n\n/*\n This is causing inconsitency of data in month view calendar\n.rbc-event-content {\n  font-size: 12px !important;\n} */\n\n/* Class to remove spacing from slots in day and week view */\n.rbc-day-slot .rbc-events-container {\n  margin-right: 0 !important;\n}\n\n/* Hide the current time indicator green line */\n/* .rbc-current-time-indicator {\n  display: none;\n} */\n\n/*\n To add the scrolling in month view if slots are multiple\n.rbc-row-content-scroll-container {\n  height: 100%;\n  overflow-y: auto !important;\n\n  &::-webkit-scrollbar {\n    width: 10px !important;\n  }\n  scrollbar-width: thin !important;\n  -ms-overflow-style: scrollbar !important;\n} */\n\n.rbc-overlay {\n  max-height: 150px !important;\n  overflow: auto;\n  max-width: 400px !important;\n}\n\n.maxwidth {\n  width: max-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
